module.exports = __webpack_public_path__ + "img/Maldives.245bf7a2.png";